import { Category } from '@/types/category';
import { create } from 'zustand';

const LAST_CATEGORY_KEY = 'lastSelectedCategorySpotlight';

type StateSelectedCategory = {
  selectedCategory: Category | null;
  lastSelectedCategoryId: string | null;
};

type ActionSelectedCAtegory = {
  updateSelectedCategory: (selectedCategory: StateSelectedCategory['selectedCategory']) => void;
  initializeFromCategories: (categories: Category[]) => void;
};

const saveLastCategoryId = (categoryId: string) => {
  try {
    sessionStorage.setItem(LAST_CATEGORY_KEY, categoryId);
  } catch (error) {
    console.warn('Failed to save last category to sessionStorage:', error);
  }
};

const getLastCategoryId = (): string | null => {
  try {
    return sessionStorage.getItem(LAST_CATEGORY_KEY);
  } catch (error) {
    console.warn('Failed to load last category from sessionStorage:', error);
    return null;
  }
};

const useActionsCategories = create<StateSelectedCategory & ActionSelectedCAtegory>((set, get) => ({
  selectedCategory: null,
  lastSelectedCategoryId: getLastCategoryId(),

  updateSelectedCategory: (selectedCategory) => {
    if (selectedCategory?.id) {
      saveLastCategoryId(selectedCategory.id);
    }

    set(() => ({
      selectedCategory,
      lastSelectedCategoryId: selectedCategory?.id || null,
    }));
  },

  initializeFromCategories: (categories) => {
    const availableCategories = categories.filter((c) => c.name !== 'Uncategorized' && !c.isArchived);

    if (availableCategories.length === 0) {
      return;
    }

    const { lastSelectedCategoryId } = get();
    let categoryToSelect: Category;

    if (lastSelectedCategoryId) {
      const lastCategory = availableCategories.find((c) => c.id === lastSelectedCategoryId);
      if (lastCategory) {
        categoryToSelect = lastCategory;
      } else {
        categoryToSelect = availableCategories[0];
      }
    } else {
      categoryToSelect = availableCategories[0];
    }

    set(() => ({
      selectedCategory: categoryToSelect,
      lastSelectedCategoryId: categoryToSelect.id,
    }));
  },
}));

export { useActionsCategories };
